import { render, staticRenderFns } from "./pushAdmin.vue?vue&type=template&id=6c78b116&scoped=true"
import script from "./pushAdmin.vue?vue&type=script&lang=js"
export * from "./pushAdmin.vue?vue&type=script&lang=js"
import style0 from "./pushAdmin.vue?vue&type=style&index=0&id=6c78b116&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c78b116",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c78b116')) {
      api.createRecord('6c78b116', component.options)
    } else {
      api.reload('6c78b116', component.options)
    }
    module.hot.accept("./pushAdmin.vue?vue&type=template&id=6c78b116&scoped=true", function () {
      api.rerender('6c78b116', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appBasicSetup/components/pushAdmin.vue"
export default component.exports